import React, { memo } from "react";
import { Box } from "@mui/material";
import { formatCellTimeRange, getCellLabel, getStatusConfig } from "../statusConfig";

const CELL_WIDTH = 64;
const CELL_HEIGHT = 36;

const MatrixCell = memo(({ cell, onClick, disabled }) => {
  const label = getCellLabel(cell);
  const cfg = cell ? getStatusConfig(cell.eStatus) : null;

  const title = (() => {
    if (!cell) return "Click to set availability";
    const parts = [cfg.label];
    const timeRange = formatCellTimeRange(cell.time_from, cell.time_to);
    if (timeRange) {
      parts.push(timeRange.replace("-", " – "));
    }
    if (cell.vNotes) parts.push(cell.vNotes);
    return parts.join(" — ");
  })();

  return (
    <Box
      title={title}
      onClick={disabled ? undefined : onClick}
      sx={{
        width: CELL_WIDTH,
        minWidth: CELL_WIDTH,
        height: CELL_HEIGHT,
        borderRight: "1px solid",
        borderBottom: "1px solid",
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.7rem",
        fontWeight: 600,
        cursor: disabled ? "default" : "pointer",
        bgcolor: cell ? cfg.bg : "background.paper",
        color: cell ? cfg.color : "text.disabled",
        userSelect: "none",
        "&:hover": disabled
          ? {}
          : {
              outline: "2px solid",
              outlineColor: "primary.main",
              outlineOffset: -2,
              zIndex: 1,
            },
      }}
    >
      {label}
    </Box>
  );
});

MatrixCell.displayName = "MatrixCell";

export { CELL_WIDTH, CELL_HEIGHT };
export default MatrixCell;
